const allowedBlocks = {}
//restrict to specific block names
allowedBlocks.media = [ 'core/image', 'core/video', 'core/audio' ,'core/gallery', 'core/cover' , 'core/media-text' ];
//User can comment on whole block/@author Pooja Bhimani/@since EDD - 3.0.1
allowedBlocks.text = ['core/paragraph','core/heading','core/list','core/list-item','core/quote','core/preformatted','core/verse','core/table','core/pullquote','core/file','core/button','core/code', 'core/freeform'];
allowedBlocks.excluded = [''];

export default allowedBlocks;